import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { FunctionService } from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-text-name-config',
  templateUrl: './text-name-config.component.html',
  styleUrls: ['./text-name-config.component.scss']
})
export class AtwTextNameConfig implements OnInit {
  @Input() data_tool: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() type_config : string; // xác định trang đang ở page hay preview
  // @Input() id_subproject : any;
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    },
    {
      title: 'cau_hinh_bo_goc',
      index: 2,
    }
  ];
  customize = []

  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};
  none: boolean = false; // có chọn PHONG CÁCH hay chưa (true=>chưa; false:đã chọn)

  unSelected: any;
  dataAfterChange: any  = {}
  id_subproject: any = "";
  link_type: any = [
    {
      name: 'Mở trong trang mới',
      value: '_blank'
    },
    {
      name: 'Mở trong trang hiện tại',
      value: '_self'
    }
  ]

  text_style: any = [
    {
      title: 'tieu_de_1',
      fontSize: '68px',
      name: 'h1',
      font: 21
    },
    {
      title: 'tieu_de_2',
      fontSize: '48px',
      name: 'h2',
      font: 19
    },
    {
      title: 'tieu_de_3',
      fontSize: '36px',
      name: 'h3',
      font: 18
    },
    {
      title: 'tieu_de_4',
      fontSize: '26px',
      name: 'h4',
      font: 17
    },
    {
      title: 'tieu_de_5',
      fontSize: '20px',
      name: 'h5',
      font: 16
    },
    {
      title: 'tieu_de_6',
      fontSize: '18px',
      name: 'h6',
      font: 15
    },
    {
      title: 'van_ban',
      fontSize: '18px',
      name: 'p',
      font: 14
    },
    {
      title: 'van_ban_quan_trong',
      fontSize: '18px',
      name: 'strong',
      font: 14
    },
    {
      title: 'van_ban_nho',
      fontSize: '16px',
      name: 'small',
      font: 13
    },
    {
      title: 'trich_dan',
      fontSize: '18px',
      name: 'Blockquote',
      font: 14
    }
  ];
  /** Danh sách giải thích loại văn bản tương ứng SEO */
  seoTextTypes: any = [
    { tag: 'tieu_de_1', explain: 'dung_cho_tieu_de_chinh', usage: 'chi_dung_mot_lan_trong_trang' },
    { tag: 'tieu_de_2_den_tieu_de_6', explain: 'dung_cho_cac_tieu_de_phu', usage: 'dung_theo_thu_tu_phan_cap_khong_bo_bac' },
    { tag: 'van_ban', explain: 'dung_cho_van_ban' },
    { tag: 'van_ban_quan_trong', explain: 'dung_cho_van_ban', usage: 'chi_de_nhan_y_quan_trong_dung_tiet_che' },
  ];

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb, 
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
  ) {
 
  }

  ngOnInit(): void { 
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/text.json'), 
    ]) .subscribe(([fonts, effects]:any)=>{
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })

    // Kiểm tra đã chọn Phong cách hay chưa
    // if(!this.class['text-name__content']['text-shadow']
    //   && !this.class['text-name']['background-color']
    //   && this.class['text-name__content']['-webkit-text-stroke-width'] == 0) {
    //     this.dispatchStyles('');
    // }

    if (!this.config.text_type) {
      this.config.text_type = 'p';
    }
    if (!this.config.curve) {
      this.config.curve = {
        "radius": "170",
        "angle": "100",
        "rotate": "-85",
        "isCurve": false,
        "isCurveReverse": false
      }
    }
    if (!this.class['text-name__curve']) {
      this.class['text-name__curve'] = {
        "list-style": "none",
        "font-family": "inherit",
        "width": "340px",
        "height": "340px"
      };
    }
    if (!this.class['text-name__curve-item']) {
      this.class['text-name__curve-item'] = {
        "background-image": "",
        "height": "100%",
        "left": "50%",
        "top": "0px",
        "position": "absolute",
        "transform-origin": "center",
        "font-family": "inherit"
      };
    }
  }
  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }  
  }

  ngOnDestroy() {
    this.saveDataProperties();
  }

  openBgColor() {
    if (isPlatformBrowser(this.platformId))
    document.getElementById('input-color').click();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[0])
  }
  // Phần GRADIENT
  
  /**
   * Cập nhật Gradient
   */
  handleSetGradientText() {
    if (this.config['background-image'].gradient_check) {
      this.class['text-name__content']['background-image'] = `linear-gradient(${this.config['background-image']['gradient_direction']} ${this.config['background-image']['gradient_arr_gradient']})`;
      this.class['text-name__content']['-webkit-text-fill-color'] = 'transparent';
      this.class['text-name__content']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['text-name__content']['background-image'] = 'none';
      this.class['text-name__content']['-webkit-text-fill-color'] = 'unset';
      this.class['text-name__content']['-webkit-background-clip'] = 'unset';
    }
    this.updateObject();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    this.config['background-image']['gradient_direction'] = direction.direction;
    this.handleSetGradientText();
  }
  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    this.config['background-image']['gradient_opacity'] = e.target.value;
    const newArr = this.config['background-image']['gradient_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['gradient_opacity'] / 100})`
    })
    this.config['background-image']['gradient_arr_gradient'] = newArr;
    
    this.handleSetGradientText();
  }
  openbgGradient() {
    if (isPlatformBrowser(this.platformId))
    document.getElementById('input-gradient').click();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradient() {
    this.config['background-image']['gradient_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image']['gradient_background_color'])}, ${this.config['background-image']['gradient_opacity'] / 100})`
    );
    this.handleSetGradientText();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradient(index) {
    this.config['background-image']['gradient_arr_gradient'].splice(index, 1);
    this.handleSetGradientText();
  }
  
  /**
    * Cập nhật link page
    * @param value 
    */
  updateLinkPage(value) {
    
    this.unSelected = value.link;
    if (this.unSelected != null && this.unSelected.length > 0) {
      this.updateCss('data', this.data_tool.data);
    }
    if (value.hyper_link != null && value.hyper_link.length > 0) {
      this.updateCss('data', this.data_tool.data);
    }
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update config`
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        
      })
  }

  /**
   * Set style changed
   * @param name : tên trường data cần lưu
   * @param value : giá trị data
   */
  updateCss(name, key) {
    // lấy tên và giá trị style đã thay đổi.
    this.dataAfterChange[name] = { ...key }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại. 
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };

  /**
   * Cập nhật lưu data vào database.
   */
  saveDataProperties() {
    if (Object.keys(this.dataAfterChange).length)
      this.vhQueryAutoWeb.updateObject(this.data_tool._id, this.dataAfterChange)
        .then((bool) => {
          
        }, error => {
          console.error(error)
        })
  }
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event){
    if(event.width) this.class['text-name']['width'] = event.width + 'px';
    if(event.height) this.class['text-name']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

  /**
   * Cập nhật Kiểu văn bản
   */
  handleSetTextStyle(action) {
    this.class['text-name__content']['font-size'] = this.text_style.find(style => style.name === action)['fontSize'];
    switch (action) {
      case "Blockquote":
        this.class['text-name__content']['border-left-width'] = '10px';
        this.class['text-name__content']['padding-left'] = '10px';
        break;
      default:
        this.class['text-name__content']['border-left-width'] = '0';
        this.class['text-name__content']['padding-left'] = '0';
    }

    // this.handleSetCurveText();

    this.updateObject();
  }
}

